import { render, staticRenderFns } from "./ApplicantDetailResume.vue?vue&type=template&id=232bc174"
import script from "./ApplicantDetailResume.vue?vue&type=script&lang=js"
export * from "./ApplicantDetailResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports